import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../utils/useAuth';

import logo from '../assets/logos/logo-enstock-blanco.svg';
import '../styles/pages/LoginPage.scss';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const navigate = useNavigate();
  const auth = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await auth.login(username, password);
    setLoading(false);
    if (result.success) {
      navigate('/admin/sync');
    } else {
      setError(result.message || 'Credenciales incorrectas');
    }
  };

  return (
    <div className="LP">
      <div className="LP__card">
        <div className="LP__brand">
          <img src={logo} alt="En Stock Promocionales" className="LP__logo" />
          <span className="LP__badge">Panel Admin</span>
        </div>

        <h1 className="LP__title">Iniciar sesión</h1>
        <p className="LP__sub">Acceso exclusivo para administradores</p>

        <form className="LP__form" onSubmit={handleLogin}>
          <div className="LP__field">
            <label className="LP__label" htmlFor="lp-user">Usuario</label>
            <input
              id="lp-user"
              className="LP__input"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="nombre de usuario"
              autoComplete="username"
              required
            />
          </div>

          <div className="LP__field">
            <label className="LP__label" htmlFor="lp-pass">Contraseña</label>
            <input
              id="lp-pass"
              className="LP__input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="current-password"
              required
            />
          </div>

          {error && <p className="LP__error">{error}</p>}

          <button className="LP__btn" type="submit" disabled={loading}>
            {loading ? <span className="LP__spinner" /> : 'Iniciar sesión'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
